export const ROOT = '';
export const MAIN_PAGE_ROUTE = `${ROOT}/:id`;
export const LOGIN_PAGE_ROUTE = `${ROOT}/login`;
